import { Component } from '@angular/core';


export class NgxSchedulerComponent {
  projectTitle: string = 'ngx scheduler';
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-scheduler',
  template: 'Hello world from the {{ projectTitle }} module!'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
